import { Component } from "@angular/core";
import { ComponentBase } from '../../../../../../apps/idl/src/helpers/ComponentBase';
import { ApplicationService } from '../../../../../../apps/idl/src/services/security/application.service';
import { PlatformService } from '../../../../../../apps/idl/src/services/security/platform.service';
import { BatteryService } from '../../../../../../apps/idl/src/modules/battery/services/battery.service';

@Component({ template: "" })
export abstract class AppComponentBase extends ComponentBase {

	//#region METHODS

	constructor(
		psvcApplication: ApplicationService,
		psvcPlatform: PlatformService,
		psvcBattery: BatteryService
	) {
		super();
		psvcApplication.markAppStart();

		if (psvcPlatform.isMobileApp) {
			psvcBattery.logOnLowBattery();
			psvcApplication.logOnPause();
			psvcApplication.logOnResume();
		}
	}

	//#endregion

}
